import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import Cluster from '../Support/Cluster';

const stackList = (props) => {

	if(!props.data) return null;

	let rows = Object.keys(props.data)
		.map(row => {

			const m = props.data[row];
			const r = +row + 1;

			let toggle_icon = <Cluster><span className='mtable__btn__icon'><i className='fas fa-eye'></i></span><span className='mtable__btn__text'> Out</span></Cluster>;
			if(+m.hidden) {
				toggle_icon = <Cluster><span className='mtable__btn__icon mtable__btn__icon--slashed'><i className='fas fa-eye'></i></span><span className='mtable__btn__text'> In</span></Cluster>;
			}

			let prompt = '';
			let remove_action = props.rdxPrepOffer.bind(null,props.context,row);
			let remove_text = ' Remove';
			if(m.deleting) {
				prompt = <div className='prompt'><p>Do you want to remove this item? <button className='prompt__btn' onClick={props.rdxFreeOffer.bind(null)}>Cancel</button> <button className='prompt__btn prompt__btn--red' onClick={props.rdxDropOffer.bind(null)}>Remove</button></p><div className='prompt__pointer'></div></div>;
				remove_action = props.rdxFreeOffer.bind(null);
				remove_text = ' Cancel';
			}

			let row_classes = [];
			if(+m.hidden) row_classes.push('mtable__row-disabled');
			if(m.accepted) row_classes.push('mtable__row-accepted');

			let controls = (
				<Cluster>
					<td className='mtable__c1'><button className='mtable__btn' onClick={remove_action}><i className='fas fa-minus-circle'></i><span className='mtable__btn__text'>{remove_text}</span></button></td>
					<td className='mtable__c2'><button className='mtable__btn' onClick={props.rdxToggleOffer.bind(null,props.context,row)}>{toggle_icon}</button></td>
				</Cluster>
			);
			if(props.locked) {
				if(m.accepted) {
					controls = (
						<Cluster>
							<td className='mtable__c12' colSpan='2'>*</td>
						</Cluster>
					);
				}
				else {
					controls = (
						<Cluster>
							<td className='mtable__c1'> </td>
							<td className='mtable__c2'> </td>
						</Cluster>
					);
				}
			}

			return (
				<tr key={r} className={row_classes.join(' ')}>
					{controls}
					<td className='mtable__c3'>{r}{prompt}</td>
					<td className='mtable__c4'><input type='text' value={m.description} placeholder='Item description' disabled={props.locked ? 'disabled' : ''} onChange={
						(event) => {props.rdxEditOffer(props.context,row,'description',event.target.value)}} /></td>
					<td className='mtable__c5'><input type='number' value={m.value} disabled={props.locked ? 'disabled' : ''} onChange={
						(event) => {props.rdxEditOffer(props.context,row,'value',event.target.value)}} /></td>
				</tr>
			);

		});

	rows.reverse();

	let new_btn = null;
	if(rows.length && !props.locked) new_btn = <button className='mtable__btn' onClick={props.rdxAddOffer.bind(null,props.context)}><i className='fas fa-plus-circle'></i> New</button>;

	let thead = null;
	if(rows.length) thead= (
		<thead>
			<tr>
				<th colSpan='2'>{new_btn}</th>
				<th className='align-center'>#</th>
				<th><span className='align-input'>Description</span></th>
				<th className='align-right'><span className='align-input'>Amount<span className='mtable__thead__extra'> ($)</span></span></th>
			</tr>
		</thead>
	);

	let tfoot = null;
	if(!rows.length) tfoot = (
		<tfoot>
			<tr>
				<td className='mtable__full' colSpan='5'>
					<button className='huge-btn huge-btn--brown huge-btn--not-so-huge' onClick={props.rdxAddOffer.bind(null,props.context)}>
						{props.context === 'counter' ? 'Add First Counter Offer' : 'Add First Offer'}
					</button>
				</td>
			</tr>
		</tfoot>
	);

	return (
		<div className='breaklist'>
			<table className='mtable'>
				{thead}
				<tbody>
					{rows}
				</tbody>
				{tfoot}
			</table>
		</div>
	);

}

const mapDispatchToProps = dispatch => {
	return {
		rdxAddOffer: (context) => 						dispatch(actions.addOffer(context)),
		rdxEditOffer: (context,row,item,value) => 		dispatch(actions.editOffer(context,row,item,value)),
		rdxToggleOffer: (context,row) => 				dispatch(actions.toggleOffer(context,row)),
		rdxPrepOffer: (context,row) => 					dispatch(actions.prepOffer(context,row)),
		rdxFreeOffer: () => 							dispatch(actions.freeOffer()),
		rdxDropOffer: () => 							dispatch(actions.dropOffer()),
	};
}


export default connect(null, mapDispatchToProps)(stackList);


// WEBPACK FOOTER //
// ./src/UI/StackList.js